(function () {
  if (window.__fluffUnderlineSystemInitialized) return;
  window.__fluffUnderlineSystemInitialized = true;

  const textSelector = "[data-fluff-underline-text]";
  const animatedSvgSelector =
    '.underline-wrapper[data-enable-animation="true"] .underline-svg';
  const staticSvgSelector =
    '.underline-wrapper[data-enable-animation="false"] .underline-svg';
  const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  let globalObserver = null;
  const observedElements = new Set();
  let initTimeout;
  let resizeTimeout;
  let shopifySectionTimeout;

  function getTextTargets(root) {
    const targets = [];
    if (root.matches && root.matches(textSelector)) targets.push(root);
    if (root.querySelectorAll) targets.push(...root.querySelectorAll(textSelector));
    return targets;
  }

  function hasUnderlineWrappers(root) {
    return getTextTargets(root).some((target) =>
      target.querySelector(".underline-wrapper")
    );
  }

  function fitTextToOneLine(textElement) {
    textElement.style.fontSize = "";
    const defaultFontSize = parseFloat(getComputedStyle(textElement).fontSize);
    const wrapper = textElement.parentElement;
    if (!wrapper || wrapper.scrollWidth <= wrapper.clientWidth) return;

    let lo = 8;
    let hi = defaultFontSize;
    while (hi - lo > 0.5) {
      const mid = (lo + hi) / 2;
      textElement.style.fontSize = `${mid}px`;
      if (wrapper.scrollWidth <= wrapper.clientWidth) {
        lo = mid;
      } else {
        hi = mid;
      }
    }
    textElement.style.fontSize = `${lo}px`;
  }

  function getTextWidth(textElement) {
    for (const node of textElement.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        const range = document.createRange();
        range.selectNode(node);
        const width = range.getBoundingClientRect().width;
        if (width > 0) return width;
      }
    }
    return textElement.getBoundingClientRect().width;
  }

  function updateSvgPath(svgElement, pathElement, width) {
    const height = 6;
    const centerY = height / 2;
    const scaleX = width / 172;
    const scaledPath = `M${1.5 * scaleX} ${centerY}
        C${40.8352 * scaleX} ${centerY - 1},
         ${80.0597 * scaleX} ${centerY - 1.5},
         ${119.442 * scaleX} ${centerY - 1.5}
        C${135.703 * scaleX} ${centerY - 1.5},
         ${184.489 * scaleX} ${centerY - 1.5},
         ${168.227 * scaleX} ${centerY - 1.5}
        C${152.209 * scaleX} ${centerY - 1.5},
         ${136.191 * scaleX} ${centerY - 1.5},
         ${120.173 * scaleX} ${centerY - 1.5}
        C${99.6525 * scaleX} ${centerY - 1.5},
         ${79.1698 * scaleX} ${centerY - 1.65},
         ${58.6949 * scaleX} ${centerY - 0.05}
        C${57.3803 * scaleX} ${centerY + 0.05},
         ${45.8707 * scaleX} ${centerY + 0.7},
         ${46.6291 * scaleX} ${centerY + 1.5}`;
    svgElement.setAttribute("viewBox", `0 0 ${width} ${height}`);
    pathElement.setAttribute("d", scaledPath);
  }

  function updateUnderlines(root) {
    getTextTargets(root).forEach((textElement) => {
      const svgElement = textElement.querySelector(".underline-svg");
      const pathElement = textElement.querySelector(".line-path");
      if (!svgElement || !pathElement) return;

      fitTextToOneLine(textElement);
      const width = getTextWidth(textElement);
      if (width > 0) updateSvgPath(svgElement, pathElement, width);
      if (textElement.dataset.textAnimation === "true") {
        textElement.classList.add("is-ready");
      }
    });
  }

  function makeStatic(root) {
    getTextTargets(root).forEach((textElement) => {
      if (textElement.dataset.textAnimation === "true") {
        textElement.classList.add("is-ready");
        textElement.style.opacity = "1";
        textElement.style.transition = "none";
      }
    });
    root.querySelectorAll(".underline-svg").forEach((svgElement) => {
      svgElement.style.strokeDasharray = "none";
      svgElement.style.strokeDashoffset = "0";
      svgElement.style.transition = "none";
      svgElement.dataset.animated = "true";
    });
  }

  function startUnderlineAnimation(svgElement) {
    const wrapper = svgElement.closest(".underline-wrapper");
    if (
      reducedMotionQuery.matches ||
      !wrapper ||
      wrapper.getAttribute("data-enable-animation") !== "true" ||
      svgElement.dataset.animating === "true"
    ) {
      return;
    }

    svgElement.dataset.animating = "true";
    svgElement.style.transition = "none";
    svgElement.style.strokeDashoffset = "1800";
    void svgElement.offsetWidth;
    svgElement.style.transition = "stroke-dashoffset 3s ease-in-out";
    svgElement.style.strokeDashoffset = "0";
    setTimeout(() => {
      svgElement.dataset.animating = "false";
    }, 3000);
  }

  function subscribeNewElements(root) {
    if (!globalObserver || reducedMotionQuery.matches) return;
    root.querySelectorAll(animatedSvgSelector).forEach((svgElement) => {
      if (!observedElements.has(svgElement) && !svgElement.dataset.observed) {
        svgElement.style.strokeDasharray = "1800";
        svgElement.style.strokeDashoffset = "1800";
        globalObserver.observe(svgElement);
        observedElements.add(svgElement);
        svgElement.dataset.observed = "true";
      }
    });
  }

  function initIntersectionObserver(root) {
    if (reducedMotionQuery.matches || !root.querySelector(animatedSvgSelector)) {
      return;
    }

    if (!globalObserver) {
      globalObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const svgElement = entry.target;
          if (entry.isIntersecting && !svgElement.dataset.animated) {
            startUnderlineAnimation(svgElement);
            svgElement.dataset.animated = "true";
          }
        });
      });
    }
    subscribeNewElements(root);
  }

  function initStaticUnderlines(root) {
    root.querySelectorAll(staticSvgSelector).forEach((svgElement) => {
      svgElement.style.strokeDasharray = "none";
      svgElement.style.strokeDashoffset = "0";
      svgElement.style.transition = "none";
      svgElement.dataset.animated = "true";
    });
  }

  function init(root = document) {
    if (!hasUnderlineWrappers(root)) return;
    clearTimeout(initTimeout);
    initTimeout = setTimeout(() => {
      updateUnderlines(root);
      if (reducedMotionQuery.matches) {
        makeStatic(root);
        return;
      }
      initStaticUnderlines(root);
      initIntersectionObserver(root);
    }, 300);
  }

  function resetUnderlines(root) {
    getTextTargets(root).forEach((textElement) => {
      textElement.classList.remove("is-ready");
      textElement.style.removeProperty("opacity");
      textElement.style.removeProperty("transition");
    });
    root.querySelectorAll(".underline-svg").forEach((svgElement) => {
      if (globalObserver) globalObserver.unobserve(svgElement);
      observedElements.delete(svgElement);
      delete svgElement.dataset.animated;
      delete svgElement.dataset.observed;
      delete svgElement.dataset.animating;
      svgElement.style.removeProperty("stroke-dasharray");
      svgElement.style.removeProperty("stroke-dashoffset");
      svgElement.style.removeProperty("transition");
    });
  }

  function reinitUnderlineSystem() {
    resetUnderlines(document);
    if (globalObserver) {
      globalObserver.disconnect();
      globalObserver = null;
    }
    observedElements.clear();
    init();
  }

  function onReducedMotionChange(event) {
    if (event.matches) {
      if (globalObserver) globalObserver.disconnect();
      globalObserver = null;
      observedElements.clear();
      updateUnderlines(document);
      makeStatic(document);
      return;
    }
    reinitUnderlineSystem();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    setTimeout(() => init(), 100);
  }

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (!hasUnderlineWrappers(document)) return;
      updateUnderlines(document);
      if (reducedMotionQuery.matches) makeStatic(document);
      else initStaticUnderlines(document);
    }, 150);
  });

  if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener("change", onReducedMotionChange);
  } else {
    reducedMotionQuery.addListener(onReducedMotionChange);
  }

  if (typeof Shopify !== "undefined") {
    document.addEventListener("shopify:section:load", (event) => {
      const section = event.target;
      if (!hasUnderlineWrappers(section)) return;
      clearTimeout(shopifySectionTimeout);
      shopifySectionTimeout = setTimeout(() => {
        resetUnderlines(section);
        init(section);
      }, 100);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      resetUnderlines(event.target);
    });
  }

  window.reinitUnderlineSystem = reinitUnderlineSystem;
})();
